import React, { type ReactNode } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Stack, Typography } from '@mui/material';
import { mainContentScrollSx } from '../layout/drawerConstants';

type CollapsibleKeteranganSplitProps = {
  keterangan: ReactNode;
  children: ReactNode;
  label?: string;
  toggleTestId?: string;
};

/**
 * Info block + main grid in a single scroll pane.
 */
export function CollapsibleKeteranganSplit({
  keterangan,
  children,
  label = 'Info',
  toggleTestId,
}: CollapsibleKeteranganSplitProps) {
  return (
    <Box
      sx={{
        ...mainContentScrollSx,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {keterangan ? (
        <>
          <Stack
            direction="row"
            alignItems="center"
            spacing={0.75}
            data-testid={toggleTestId}
            sx={{ color: 'text.secondary', mb: 1, flexShrink: 0 }}
          >
            <InfoOutlinedIcon fontSize="small" />
            <Typography variant="subtitle2" component="span" sx={{ fontWeight: 600 }}>
              {label}
            </Typography>
          </Stack>
          <Box sx={{ mb: 1.5, flexShrink: 0 }}>{keterangan}</Box>
        </>
      ) : null}
      <Box sx={{ pb: 1 }}>{children}</Box>
    </Box>
  );
}
